<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->

<p-text
  [size]="{ base: 'sm', m: 'md' }"
  class="mt-fluid-lg"
  [innerText]="'signup.confirm.owner.confirmIdentity.dateOfBirth.label' | translate"
></p-text>
<form [formGroup]="dateOfBirthFormGroup">
  <p-input-date
    id="dateOfBirthInputField"
    name="dateOfBirth"
    class="mt-fluid-lg w-1/2 sm:w-1/3 fs-exclude"
    formControlName="dateOfBirth"
    [attr.data-e2e]="'birthday-widget-input-date'"
    [attr.data-has-error]="!!dateOfBirthFormControlErrorMessage"
    [state]="!!dateOfBirthFormControlErrorMessage ? 'error' : 'none'"
    [message]="dateOfBirthFormControlErrorMessage"
    [label]="'signup.confirm.owner.confirmIdentity.dateOfBirth.input.label' | translate"
    [min]="minDate"
    [max]="maxDate"
  >
    <span slot="message" class="lg:w-[40vw] 2xl:w-[30vw] md:text-balance">{{ dateOfBirthFormControlErrorMessage }}</span>
  </p-input-date>
  <p-button
    (click)="onSubmitOTP()"
    class="mt-fluid-md w-full xs:w-auto"
    variant="primary"
    data-e2e="dob-submit-button"
    [disabled]="(codeStatus$ | async) === ConfirmationCodeStatus.CODE_STATUS_VALIDATION_PENDING"
    [loading]="(codeStatus$ | async) === ConfirmationCodeStatus.CODE_STATUS_VALIDATION_PENDING"
    [myprofileSignupUiTrack]="{
      clickElementType: 'button',
      clickElementId: 'call_to_action',
      clickElementName: 'confirm_dob',
      pageName: currentPageName,
      eventAction: 'PAGMyPorsche_SignUpConfirmDob_Click',
    }"
  >
    {{ 'signup.confirm.owner.confirmIdentity.dateOfBirth.button.label' | translate }}
  </p-button>
</form>
